/* eslint-disable max-len, no-irregular-whitespace */
export const REPLACEMENT_TEXT_REG = /{link(?:Start|End)}/;

// inner or server errors
export const INNER_ERROR_VALIDATION_ERRORS = 'VALIDATION_ERRORS';
export const AWS_SIGNED_IN_USER_SESSION_INVALID = 'AWS_SIGNED_IN_USER_SESSION_INVALID';
export const CHECK_USER_AUTHENTICATED_ERROR = 'CHECK_USER_AUTHENTICATED_ERROR';

// errors from ims
export const IMS_200A_ERROR_MESSAGE = 'ログインIDまたはパスワードが間違っています。';
export const IMS_200B_ERROR_MESSAGE = 'メールアドレスまたはパスワードが正しくありません。';
export const IMS_201_ERROR_MESSAGE = `パスワード失敗回数が上限を超えています。
Myページの「パスワードロック解除画面」よりパスワードを初期化してください。`;
export const IMS_202_ERROR_MESSAGE =
  '入力されたパスワードは初期パスワードです。Myページにログインして「初期パスワード変更画面」よりパスワードを変更してください。';
export const IMS_203_ERROR_MESSAGE = 'ご入力いただいたメールアドレスではログインできません。';
export const IMS_800_ERROR_MESSAGE =
  'システムメンテナンス中のため、一時的にご利用いただけません。詳細についてMyページよりご確認ください。';
export const IMS_XXX_ERROR_MESSAGE = `Myページへログインできませんでした。
しばらくしてから再度実行してください。`;

export const IMS_200A = 'IMS-200a';
export const IMS_200B = 'IMS-200b';
export const IMS_201 = 'IMS-201';
export const IMS_202 = 'IMS-202';
export const IMS_203 = 'IMS-203';
export const IMS_800 = 'IMS-800';

export const IMS_REG = /IMS-\d{3}\w?/;

// error in otp/passkey login
export const UNEXPECTED_ERROR_MESSAGE =
  'ログインを完了できませんでした。再度お試しいただくか、解決しない場合はお客様サポートまでお問合せください。';
export const UNEXPECTED_ERROR_IN_PASSKEY_MESSAGE = 'ログインを完了できませんでした。再度お試しください。';
export const IMS_339_ERROR_MESSAGE = '認証コードが正しくありません。';
export const IMS_340_ERROR_MESSAGE =
  '認証コードの利用時間が超過したか無効化されています。再度ログインをお試しください。';
export const IMS_INITIAL_PASSWORD_ERROR_MESSAGE =
  'Myページにログインし、「初期パスワード変更変更画面」より、パスワードを変更してください。';
export const IMS_SYSTEM_MAINTENANCE_ERROR_MESSAGE = 'メンテナンス中のため、ご利用できません。';

// maintenance
export const MAINTENANCE_ERROR_MESSAGE_WEB = `現在はメンテナンス実施中です。
メンテナンス時間は{linkStart}こちら{linkEnd}をご参照ください。`;
export const MAINTENANCE_ERROR_MESSAGE_MOBILE = `現在はメンテナンス実施中です。
メンテナンス実施日時等についてはMyページよりご確認ください。`;
export const MAINTENANCE_LOGIN_ERROR_MESSAGE = `現在メンテナンス中のため、ログインができません。
メンテナンス時間は{linkStart}こちら{linkEnd}をご参照ください。`;
export const MAINTENANCE_MODAL_TITLE = 'システムメンテナンス中';
export const MAINTENANCE_MODAL_BUTTON = '閉じる';
export const BUILDER_DISABLED = 'ビルダー機能はメンテナンス中です。';

// notExists
const FX_NOT_EXIST_TITLE = 'トライオート FX未開設';
const FX_NOT_EXIST_ERROR_MESSAGE_WEB = `トライオートFXをご利用いただくためには口座開設が必要です。
Myページより追加口座開設をお願いいたします。

Myページは{linkStart}こちら{linkEnd}`;
const ETF_NOT_EXIST_TITLE = 'バラエティ口座未開設';
const ETF_NOT_EXIST_ERROR_MESSAGE_WEB = `バラエティをご利用いただくためには口座開設が必要です。
Myページより追加口座開設をお願いいたします。

Myページは{linkStart}こちら{linkEnd}`;
const CFD_NOT_EXIST_TITLE = '株価指数口座未開設';
const CFD_NOT_EXIST_ERROR_MESSAGE_WEB = `株価指数をご利用いただくためには口座開設が必要です。
Myページより追加口座開設をお願いいたします。

Myページは{linkStart}こちら{linkEnd}`;

export const NOT_EXIST_BUTTON = '閉じる';
export const NOT_EXIST_ERROR_MESSAGES_WEB = Object.freeze({
  fx: FX_NOT_EXIST_ERROR_MESSAGE_WEB,
  etf: ETF_NOT_EXIST_ERROR_MESSAGE_WEB,
  cfd: CFD_NOT_EXIST_ERROR_MESSAGE_WEB,
});
export const NOT_EXIST_TITLES = Object.freeze({
  fx: FX_NOT_EXIST_TITLE,
  etf: ETF_NOT_EXIST_TITLE,
  cfd: CFD_NOT_EXIST_TITLE,
});

// lossCut
export const LOSSCUT_MODAL_TITLE = '通知';
export const LOSSCUT_MODAL_MESSAGE = `ただいまロスカット処理中です。この処理には数分かかる場合があります。\n完了し操作可能となるまでお待ちください。`;
export const LOSSCUT_MODAL_BUTTON = '閉じる';

// login
export const DISPLAYING_ERROR_ID_TOO_SHORT = 'ログインIDは半角数字8桁でご入力ください。';
export const DISPLAYING_ERROR_OTP_CODE_FORMAT = '認証コードは半角数字6桁でご入力ください。';
export const DISPLAYING_ERROR_PASSWORD_TOO_SHORT = 'パスワードは半角英数8桁以上でご入力ください。';
export const DISPLAYING_ERROR_PASSWORD_TOO_SHORT_MOBILE = 'パスワードは6文字以上20文字以下でご入力ください。';
export const DISPLAYING_ERROR_LOGIN = '取引ログインIDまたはパスワードが正しくありません。';
export const DISPLAYING_ERROR_IMS = `メールアドレス・MyページログインID・パスキーによるログインはご利用いただけません。\n取引ログインID・パスワードでログインしてください。`;
export const DISPLAYING_PASSKEY_ERROR_IMS = `現在、パスキーによるログインはご利用いただけません。\n取引ログインID・パスワードでログインしてください。`;

// server error
export const DISPLAYING_ERROR_DEFAULT = `サーバエラーが発生しました。

お手数ですが画面を更新いただくか再度ログインをお願いします。`;
export const DISPLAYING_ERROR_DEFAULT_MOBILE = `サーバエラーが発生しました。お手数ですが、再度ログインをお願いします。`;
export const DEFAULT_UNKNOWN_MESSAGE = '接続に失敗しました。';
export const SESSION_EXPIRED_ERROR_MESSAGE = `ログインセッションの有効期限が切れました。

お手数ですが再度ログインをお願いします。`;
export const NEW_SESSION_WITH_THIS_CREDENTIAL_ERROR_MESSAGE = `他の端末でログインがありました。

ログアウトします。`;
export const CONNECTION_TIMEOUT_ERROR_MESSAGE =
  '処理に失敗した可能性があります。お手数ですが画面を更新しご確認の上、しばらくたってから再度お試しください。';

// ap
export const ERROR_TITLE = 'エラー';
export const AP_GROUP_DELETE_MESSAGES = {
  apGroupIsActive: '自動売買が全て停止されていないためグループを削除できません。',
  apGroupHasOpenPositions: '自動売買に建玉があるためグループを削除できません。',
  apGroupHasOpenOrders: '自動売買に新規注文があるためグループを削除できません。',
  apGroupMultipleError: `自動売買が全て停止されていないためグループを削除できません。
	自動売買に建玉があるためグループを削除できません。
	自動売買に新規注文があるためグループを削除できません。`,
};
export const ERROR_FIELD_REQUIRED = 'の指定は必須です。';

// tech
export const TECH_LOGIC_DELETE_MESSAGES = {
  techIsActive: 'テクニカルロジックが稼働中のためロジックを削除できません。',
  techHasOpenPositions: 'テクニカルロジックに紐づく建玉があるためロジックを削除できません。',
  techHasOpenOrders: 'テクニカルロジックに紐づく自動売買注文があるためロジックを削除できません。',
};

// position delete
export const POSITIONS_ARE_STILL_DELETING = '建玉の決済が完了していないため、再度時間をおいてからお試しください。';
export const SWAP_TRANSFER_POSITIONS_VALIDATION_MESSAGE =
  '建玉が100件を超えています。建玉を100件以内にしてから振替処理を実施してください。';

// client error
export const CLIENT_ERROR_MESSAGE =
  '処理に失敗した可能性があります。お手数ですが画面を更新しご確認の上、しばらくたってから再度お試しください。';
export const CLIENT_ERROR_CODE = 'CE-001';

// 自動売買稼働時のエラー
const MAX_ACTIVE_ORDERS = '2,500';
// 総建玉数量上限、cfdはチェックしないため0Lotにする
const MAX_TOTAL_POSITION_VOLUME = {
  fx: '5,000万通貨',
  etf: '40,000口',
  cfd: '0Lot',
};
const MAX_TOTAL_POSITIONS = '1,000';
const MAX_AUTO_TRADING_GROUPS = '500';

const ASSET_TYPE_LIMIT_DESCRIPTION_URL_MAP = {
  fx: 'https://www.invast.jp/triauto/rules/#fx-method',
  etf: 'https://www.invast.jp/triauto/rules/#etf-method',
  cfd: 'https://www.invast.jp/triauto/rules/#cfd-method',
};

// 未知エラーコード時のメッセージ
const DEFAULT_ERROR = {
  short: '稼働ができませんでした。注文状況等を今一度ご確認ください。',
};

// CFD,ETF名称変更対応
const ASSET_DISPLAY_NAME_MAP = {
  fx: 'トライオートFX',
  cfd: 'トライオートCFD(株価指数)',
  etf: 'トライオートCFD(バラエティ)',
};

const getAssetDisplayName = (assetType) => ASSET_DISPLAY_NAME_MAP[assetType] ?? '';

// message functions
const getMaxActiveOrdersMessage = (productName) => `
■${productName}の有効注文件数の上限に達しています。
　上限内に収まるように注文件数を減らしてください。

　有効注文数上限：${MAX_ACTIVE_ORDERS}件`;

const getMaxTotalPositionVolumeMessage = (assetType) => `
■トライオートの総建玉数量上限に達しています。
　上限内に収まるように建玉数量を減らしてください。

　総建玉数量上限：${MAX_TOTAL_POSITION_VOLUME[assetType]}`;

const getMaxPositionVolumeMessage = (productName) => `
■${productName}の建玉数量上限に達しています。
　上限内に収まるように建玉数量を減らしてください。

　建玉数量上限については`;

const getMaxTotalPositionsMessage = (productName) => `
■${productName}の総建玉件数の上限に達しています。
　上限内に収まるように総建玉件数を減らしてください。

　総建玉件数上限：${MAX_TOTAL_POSITIONS}件`;

const getMaxAutoTradingGroupsMessage = (productName) => `
■${productName}の自動売買グループ件数の上限に達しています。
　上限内に収まるように、自動売買グループ件数を減らしてください。

　自動売買グループ件数上限：${MAX_AUTO_TRADING_GROUPS}件`;

const getInsufficientMarginMessage = (productName) => `
■${productName}の発注証拠金が不足しています。
　追加のご入金、または、発注中の新規注文を停止してください。`;

const getLimitDescriptionUrl = (assetType) => ASSET_TYPE_LIMIT_DESCRIPTION_URL_MAP[assetType] ?? '';

// ERROR_HANDLERS
const ERROR_HANDLERS = {
  'WI-10020': (assetType) => ({
    summary: getMaxActiveOrdersMessage(getAssetDisplayName(assetType)).trim(),
    short: '有効注文件数の上限に達しています。',
    url: '',
  }),

  'SA-17002': (assetType) => ({
    summary: getMaxTotalPositionVolumeMessage(assetType).trim(),
    short: '総建玉数量上限に達しています。',
    url: '',
  }),

  'SA-17009': (assetType) => ({
    summary: getMaxPositionVolumeMessage(getAssetDisplayName(assetType)).trim(),
    short: '建玉数量上限に達しています。',
    url: getLimitDescriptionUrl(assetType),
  }),

  'WI-10021': (assetType) => ({
    summary: getMaxTotalPositionsMessage(getAssetDisplayName(assetType)).trim(),
    short: '総建玉件数の上限に達しています。',
    url: '',
  }),

  'CA-00062': (assetType) => ({
    summary: getMaxAutoTradingGroupsMessage(getAssetDisplayName(assetType)).trim(),
    short: '自動売買グループ件数の上限に達しています。',
    url: '',
  }),

  'SA-12617': (assetType) => ({
    summary: getInsufficientMarginMessage(getAssetDisplayName(assetType)).trim(),
    short: '発注証拠金が不足しています。',
    url: '',
  }),
};

export const RUN_NOW_ERROR_MESSAGES = {
  allErrorTitle: '自動売買が稼働できませんでした',
  partialErrorTitle: '稼働できなかった自動売買があります',
  partialErrorText:
    '稼働した注文についてはホーム画面のポートフォリオ内にて確認できます。\n失敗した注文・テクニカルロジックについては証拠金状況や注文状況等を今一度ご確認ください。',
  supportURL: 'https://www.invast.jp/contact/',
};

export const RUN_NOW_TECH_ERROR_MESSAGES = {
  allErrorTitle: 'テクニカルロジックが稼働できませんでした',
};

export function getRunNowErrorMessageByErrorCode(assetType, errorCode) {
  const detail = ERROR_HANDLERS[errorCode]?.(assetType) ?? DEFAULT_ERROR;

  return {
    summary: detail.summary,
    short: detail.short,
    url: detail.url,
  };
}

export const OMAKASE_PLAN_MASTER_LOAD_ERROR = {
  title: 'データの取得に失敗しました。',
  body: 'お手数ですが、時間をおいてから再度お試しください。',
  buttonText: '閉じる',
};

export const OMAKASE_PLAN_NOT_FOUND = {
  title: 'オートセレクトを作成できませんでした',
  body: 'こちらのポートフォリオは、現在提供されていません。',
  buttonText: '閉じる',
};

export const STRATEGY_SET_ALL_ZERO = {
  title: 'セット数を変更できませんでした',
  body: '自動売買ロジックは最低1個以上必要です。',
  buttonText: '閉じる',
};
